import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import { AddWalletAmountSchema } from '../../../validation/validate'

import { NumericFormat } from 'react-number-format'
import { getCurrencySymbol, parseCurrencyToNumber } from '../../../helpers'
import { useAddWalletAmountMutation } from '../../../redux-toolkits/user/user.slice'

export const AddWalletAmountModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
}) => {
  const [addWalletAmount, { isLoading: creating }] =
    useAddWalletAmountMutation()

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      amount: '',
    },
    enableReinitialize: true,
    validationSchema: AddWalletAmountSchema,
    onSubmit: (values) => {
      addWalletAmount({
        amount: String(parseCurrencyToNumber(values.amount)),
      }).then((resp) => {
        if (resp.data?.success) {
          resetForm()
          setOpen(false)
          onSuccessCallback()
        }
      })
    },
  })
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={'Add quick fund amount'}
      childrenClassName="md:!max-w-[420px]"
    >
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <NumericFormat
          suffix={undefined}
          prefix={getCurrencySymbol('NGN')}
          decimalScale={2}
          thousandSeparator
          customInput={TextInput}
          type="text"
          name="amount"
          placeholder="Amount"
          value={values.amount}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={errors.amount && touched.amount ? errors.amount : ''}
          hasIcon={false}
        />

        <Button
          label="Proceed"
          type="submit"
          className="mt-10"
          disabled={!isValid || creating}
          loading={creating}
          primary
        />
      </form>
    </ModalComponent>
  )
}
